import React, { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./App.css";
import "antd/dist/reset.css";
import Footer from "./navigation/Footer";
import InitComponent from "./InitComponent";
import { enableTheme } from "./connections/atlassian/ap";

function App() {
  useEffect(() => {
    enableTheme();
  }, []);

  return (
    <Provider store={store}>
      <div className="ihub-main-app">
        <InitComponent />
        <Footer />
      </div>
    </Provider>
  );
}

export default App;
